import { Injectable } from '@angular/core'
import { takeFormSnapshot } from '@core/helpers/take-form-snapshot'

export interface TrackedUnsavedForm {
  isFormChanged: ReturnType<typeof takeFormSnapshot>
}

@Injectable({ providedIn: 'root' })
export class UnsavedFormTracker {
  components: TrackedUnsavedForm[] = []

  track(component: TrackedUnsavedForm) {
    this.components.push(component)
  }

  discard(component: TrackedUnsavedForm) {
    const isNotDeleted = (filteredComponent: TrackedUnsavedForm) => filteredComponent !== component
    this.components = this.components.filter(isNotDeleted)
  }

  hasUnsavedChanges() {
    return this.components.some((component) => component.isFormChanged())
  }
}
